import { render } from "./CatDepartamentoView.vue?vue&type=template&id=40f14e40&scoped=true"
import script from "./CatDepartamentoView.vue?vue&type=script&lang=js"
export * from "./CatDepartamentoView.vue?vue&type=script&lang=js"

import "./CatDepartamentoView.vue?vue&type=style&index=0&id=40f14e40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f14e40"]])

export default __exports__